import { useQuery } from "@tanstack/react-query";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { fetchBuildSteps } from "~/components/build/Show/lib/queries";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";
import { Build } from "~/components/build/Show/lib/types";

export function stepsQueryKey(build: Build) {
  return ["steps", build.id];
}

export function useStepsQuery(build: Build) {
  if (Features.HideBuildSidebar && Features.DisableStepsCanvasView) {
    return {
      isLoading: false,
      refetch: () => Promise.resolve(),
    };
  }

  return useQuery({
    queryKey: stepsQueryKey(build),
    queryFn: () => fetchBuildSteps(build),
    enabled: Features.ProgressiveBuildShow,
  });
}

/**
 * Get steps from the build store.
 *
 * The store is updated by the BuildContext.
 */
export function useSteps() {
  const { build } = useBuild();
  const { isLoading } = useStepsQuery(build);
  const steps = useBuildStore((state) => state.steps);
  const stepsMap = useBuildStore((state) => state.stepsMap);
  const groupStepsMap = useBuildStore((state) => state.groupStepsMap);
  const stepJobs = useBuildStore((state) => state.stepJobs);

  return {
    isLoading,
    steps,
    stepsMap,
    groupStepsMap,
    stepJobs,
  };
}
